<template>
  <div class="p-4 flex items-center gap-2 glass-frosted rounded-8xl">
    <Icon
      icon="Technology-Wireframe-Tracking"
      class="size-9"
      :class="disabled ? 'text-text-glass-disabled' : 'text-black-white'"
    />
    <div class="flex-1 flex flex-col">
      <h3 class="text-l-medium" :class="disabled ? 'text-text-glass-disabled' : 'text-black-white'">
        {{ $t('parameters.glassTracking.title') }}
      </h3>
      <p
        class="text-s-medium"
        :class="disabled ? 'text-text-glass-disabled' : 'text-text-glass-default'"
      >
        {{ $t('parameters.glassTracking.description', { sensor: sensorText }) }}
      </p>
    </div>
    <Switch
      size="lg"
      :disabled="disabled"
      :model-value="state.glassTracking.value"
      @update:model-value="actions.setGlassTracking"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { Icon, Switch } from '@rapoo/element'
  import type { ModuleSize } from '../utils/types'
  import type { ParametersContext } from '../../composables/useParameters'

  const GLASS_TRACKING_SENSORS = ['PAW3950U', 'PAW3955U'] as const

  const props = defineProps<{
    parameters: ParametersContext
    size?: ModuleSize
  }>()

  const { state, actions } = props.parameters

  const sensorText = computed(() => (state.sensor.value === 'PAW3955U' ? '3955' : '3950'))
  // 3950/3955 启用玻璃追踪
  const disabled = computed(() => !GLASS_TRACKING_SENSORS.includes(state.sensor.value as any))
</script>
